import $appConfig from "servicestack/config";
import Hotspot from "emun.catalogs/hotspots/hotspot.model";

export default class Page {
  constructor(dto = {}) {
    const page = this;
    Object.assign(this, { hotspots: [] }, dto);
    // if (dto.product) this.product = new Product(dto.product);
    if (this.url) {
      if (this.url.indexOf("http") !== 0) {
        delete this.url;
      }
    }
    this.productIds = this.getProductIds();
    this.mediaIds = this.getProductIds("Media");
    this.hotspots = this.hotspots.map((h) => new Hotspot(h));
  }

  view = "Page";

  downloadPrompt(ext) {
    // return DownloadImagesPrompt({
    //   subTitle: this.productId + " - " + this.description,
    //   id: this.id || this.sectionId,
    //   productId: this.productId,
    //   position: this.position
    // });
  }

  getProductIds(...actions) {
    return this.hotspots
      .reduce((m, h) => {
        if (actions.length === 0 || actions.includes(h.action)) {
          if (h.productIds) {
            m.push(...h.productIds);
          } else if (h.productId) {
            m.push(h.productId);
          }
        }
        return m;
      }, [])
      .filter((m) => m);
  }

  hasMedia() {
    return this.hotspots.some(
      (h) => !["Product", "MULTIITEM"].includes(h.action)
    );
  }

  getLabel($index) {
    return this.label || "Page #" + (this.pageNum || $index);
  }

  img(size = "small") {
    return this.imgs(size)[0];
  }

  imgs(size = "small") {
    const results = [];
    if ($appConfig.isOffline) {
      if (this.id === "EMPTY_PAGE") {
        results.push(
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+P+/HgAFhAJ/wlseKgAAAABJRU5ErkJggg==",
          this.url
        );
      } else {
        results.push(
          $appConfig
            .altCatalogImg(
              "page",
              this.id,
              size,
              "jpg",
              `m=${encodeURIComponent(this.modifiedOn)}`
            )
            .replace("https:", "")
        );
      }
    } else if ($appConfig.isShowroom) {
      results.push(
        $appConfig
          .catalogImg(
            "page",
            this.id,
            size,
            "jpg",
            `m=${encodeURIComponent(this.modifiedOn)}`
          )
          .replace("https:", "")
      );
    }
    if (this.url) {
      results.push(
        this.url.replace(
          /original\/([^/]+)\/([^.]+)\.jpg$/gi,
          `${size}/$1.jpg?m=${encodeURIComponent(this.modifiedOn)}`
        )
      );
    }
    results.push(
      $appConfig.catalogImg(
        "page",
        this.id,
        size,
        "jpg",
        `m=${encodeURIComponent(this.modifiedOn)}`
      ),
      $appConfig.altCatalogImg(
        "page",
        this.id,
        size,
        "jpg",
        `m=${encodeURIComponent(this.modifiedOn)}`
      )
    );
    if (this.url) {
      results.push(this.url);
    }
    return results;
  }
}
